var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserT1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.156,
    height: 32.539,
    viewBox: "0 0 28.156 32.539",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_27",
    "data-name": "Groupe 27",
    transform: "translate(470.997 -153.991)",
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_62",
    "data-name": "Trac\\xE9 62",
    d: "M-461.651,170.026a19.156,19.156,0,0,1-1.6-1.446,8.337,8.337,0,0,1-1.835-8.737,8.243,8.243,0,0,1,6.839-5.734,8.643,8.643,0,0,1,9.978,7.446,8.686,8.686,0,0,1-7.177,9.675c-.832.127-1.687.1-2.525.2a11.727,11.727,0,0,0-10.187,7.933,10.779,10.779,0,0,0-.671,3.741,1.1,1.1,0,0,0,1.233,1.261h10.455a2.436,2.436,0,0,1,.4.016,1.092,1.092,0,0,1,.9,1.109,1.094,1.094,0,0,1-.981,1.036c-.056.006-.113,0-.169,0-3.587,0-7.173.009-10.759,0a3.237,3.237,0,0,1-3.25-3.281,14.106,14.106,0,0,1,9.068-13.1C-461.826,170.1-461.725,170.057-461.651,170.026Zm4.711-13.821a6.5,6.5,0,0,0-6.476,6.483,6.512,6.512,0,0,0,6.451,6.51,6.507,6.507,0,0,0,6.543-6.417A6.5,6.5,0,0,0-456.94,156.2Z",
    fill: "#feffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_63",
    "data-name": "Trac\\xE9 63",
    d: "M-286.115,363.371c0-1.3-.007-2.552,0-3.8a1.072,1.072,0,0,1,.98-1.067,1.084,1.084,0,0,1,1.152.84,2,2,0,0,1,.029.437c0,1.182,0,2.365,0,3.593h.377q1.64,0,3.281,0a1.1,1.1,0,0,1,1.215,1.077,1.1,1.1,0,0,1-1.2,1.088c-1.206,0-2.411,0-3.668,0v.369c0,1.139.006,2.277,0,3.416a1.081,1.081,0,0,1-.965,1.083,1.088,1.088,0,0,1-1.163-.824,1.73,1.73,0,0,1-.033-.4q0-1.64,0-3.281v-.361h-1.106c-.879,0-1.759,0-2.638,0a1.086,1.086,0,0,1-1.128-1.095,1.079,1.079,0,0,1,1.12-1.067c1.116-.006,2.232,0,3.348,0Z",
    transform: "translate(-163.763 -186.049)",
    fill: "#feffff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserT1);
export default __webpack_public_path__ + "static/media/user-t1.1e1ba25411929330d0f4439a1b530f9b.svg";
export { ForwardRef as ReactComponent };